/* eslint-disable @typescript-eslint/no-explicit-any */
export var THEME_LAYOUT_TYPES;
(function (THEME_LAYOUT_TYPES) {
    THEME_LAYOUT_TYPES["ADULT"] = "adult";
    THEME_LAYOUT_TYPES["CHILD"] = "child";
})(THEME_LAYOUT_TYPES || (THEME_LAYOUT_TYPES = {}));
export var THEME_NAME_TYPES;
(function (THEME_NAME_TYPES) {
    THEME_NAME_TYPES["ARD"] = "ARD";
    THEME_NAME_TYPES["3SAT"] = "3sat";
    THEME_NAME_TYPES["ALPHA"] = "alpha";
    THEME_NAME_TYPES["ARTE"] = "Arte";
    THEME_NAME_TYPES["BR"] = "BR";
    THEME_NAME_TYPES["DAS_ERSTE"] = "Das Erste";
    THEME_NAME_TYPES["FUNK"] = "FUNK";
    THEME_NAME_TYPES["HR"] = "HR";
    THEME_NAME_TYPES["KIKA"] = "KiKA";
    THEME_NAME_TYPES["MDR"] = "MDR";
    THEME_NAME_TYPES["NDR"] = "NDR";
    THEME_NAME_TYPES["ONE"] = "One";
    THEME_NAME_TYPES["PHOENIX"] = "PHOENIX";
    THEME_NAME_TYPES["RADIO_BREMEN"] = "Radio Bremen";
    THEME_NAME_TYPES["RBB"] = "RBB";
    THEME_NAME_TYPES["SR"] = "SR";
    THEME_NAME_TYPES["SWR"] = "SWR";
    THEME_NAME_TYPES["TAGESSCHAU_24"] = "Tagesschau24";
    THEME_NAME_TYPES["WDR"] = "WDR";
    THEME_NAME_TYPES["ZDF"] = "ZDF";
    THEME_NAME_TYPES["KIDS_PRE_SCHOOL"] = "Kids pre-school";
    THEME_NAME_TYPES["KIDS_PRE_TEENS"] = "Kids pre-teens";
    THEME_NAME_TYPES["KIDS_SCHOOL"] = "Kids school";
})(THEME_NAME_TYPES || (THEME_NAME_TYPES = {}));
export var THEME_ID_TYPES;
(function (THEME_ID_TYPES) {
    THEME_ID_TYPES["DARK_ARD"] = "darkArd";
    THEME_ID_TYPES["LIGHT_ARD"] = "lightArd";
    THEME_ID_TYPES["DARK_3_SAT"] = "dark3sat";
    THEME_ID_TYPES["DARK_ALPHA"] = "darkAlpha";
    THEME_ID_TYPES["DARK_ARTE"] = "darkArte";
    THEME_ID_TYPES["DARK_BR"] = "darkBr";
    THEME_ID_TYPES["DARK_DAS_ERSTE"] = "darkDaserste";
    THEME_ID_TYPES["DARK_FUNK"] = "darkFunk";
    THEME_ID_TYPES["DARK_HR"] = "darkHr";
    THEME_ID_TYPES["DARK_KIKA"] = "darkKika";
    THEME_ID_TYPES["DARK_MDR"] = "darkMdr";
    THEME_ID_TYPES["DARK_NDR"] = "darkNdr";
    THEME_ID_TYPES["DARK_ONE"] = "darkOne";
    THEME_ID_TYPES["DARK_PHOENIX"] = "darkPhoenix";
    THEME_ID_TYPES["DARK_RADIO_BREMEN"] = "darkRadiobremen";
    THEME_ID_TYPES["DARK_RBB"] = "darkRbb";
    THEME_ID_TYPES["DARK_SR"] = "darkSr";
    THEME_ID_TYPES["DARK_SWR"] = "darkSwr";
    THEME_ID_TYPES["DARK_TAGESSCHAU_24"] = "darkTagesschau24";
    THEME_ID_TYPES["DARK_WDR"] = "darkWdr";
    THEME_ID_TYPES["DARK_ZDF"] = "darkZdf";
    THEME_ID_TYPES["KIDS_PRE_SCHOOL"] = "kidsPreSchool";
    THEME_ID_TYPES["KIDS_PRE_TEENS"] = "kidsPreTeens";
    THEME_ID_TYPES["KIDS_SCHOOL"] = "kidsSchool";
})(THEME_ID_TYPES || (THEME_ID_TYPES = {}));
